<div class="delete-payment-dialog">
  <img
    src="assets/img/success-image.svg"
    alt="Success icon"
    class="success-icon">
  <h2 class="headline">{{'PAYMENT_PAGE.MODAL.RETURN_SUCCESS' | translate}}</h2>
  <div class="btn-block">
    <button
      (click)="goToRoleList()"
      class="btn btn-link">
      {{'PAYMENT_PAGE.MODAL.RETURN_TO_PAYMENT' | translate}}
    </button>
  </div>
</div>
